import { MaterialDetailsViewModel } from "api/factories/creatives.factory";
import { useEffect, useState } from "react";

interface MaterialDetailsState {
    format: string;
    isMaterialEmpty: boolean;
    materialUrl?: string;
    thumbnailUrl: string;
    processedHeight: number;
    processedWidth: number;
}

export const useMaterialDetails = (materialDetails?: MaterialDetailsViewModel | null) => {
    const stringifiedMaterialDetails = JSON.stringify(materialDetails);
    const [state, setState] = useState<MaterialDetailsState>({
        format: "",
        isMaterialEmpty: true,
        materialUrl: "",
        thumbnailUrl: "",
        processedHeight: 0,
        processedWidth: 0,
    });

    useEffect(() => {
        const parsedMaterialDetails: MaterialDetailsViewModel = JSON.parse(stringifiedMaterialDetails);

        if (parsedMaterialDetails) {
            const {
                inputFileName,
                originalMaterialInfo,
                materialInfoPreview,
                materialBigPreview,
                processedHeight,
                processedWidth,
            } = parsedMaterialDetails;

            const materialFormat = originalMaterialInfo?.[0]?.format || "";
            const materialUrl = originalMaterialInfo?.[0]?.url;

            setState({
                format: materialFormat || "",
                isMaterialEmpty: inputFileName === "",
                materialUrl: materialFormat === "pdf" ? materialBigPreview?.url : originalMaterialInfo?.[0]?.url,
                thumbnailUrl: materialInfoPreview?.url || materialUrl || "",
                processedHeight: processedHeight,
                processedWidth: processedWidth,
            });
        }
    }, [stringifiedMaterialDetails]);

    return state;
};
